import{a as n}from"./chunk-RAAYCPUM.js";function i(...e){return n(r,e)}var r=(e,t)=>e.length>=t;export{i as a};
